<script>
	export let products;
	export let edit;
	function selectPic(product, image) {
		let needle = products[product].img.indexOf(image);
		if(needle === -1) {
			products[product].img.push(image);
		} else {
			products[product].img.splice(needle, 1);
		}
		products[product].img = products[product].img;
	}
	function img_title_resolution() {
		this.title = this.naturalWidth + ' x ' + this.naturalHeight;
	}
	import Sortable from '../components/Sortable.svelte';
</script>

<style>
	.notselected {
		filter: grayscale(100%);
		opacity: .6;
	}
	img {
		max-height: 97%;
	}
	#lightbox {
		position: fixed;
		background: rgba(0, 0, 0, 0.9);
		overflow-x: auto;
		white-space: nowrap;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 2;
	}
	#label {
		color: white;
		position: fixed;
		top: 0;
		right: 0;
		z-index: 3;
	}
	#getout {
		position: fixed;
		top: 0;
		z-index: 3;
	}
</style>

<span id="label">{products[edit].brand} {products[edit].clean_title} {products[edit].type}</span>
<button id="getout" on:click={() => edit = undefined}>get me out of here</button>
<div id="lightbox">
	<br>
	<Sortable
		family="pic-{edit}"
		bind:list={products[edit].img}
		let:item
		style="display:inline"
	>
		<img on:load={img_title_resolution} on:click={() => selectPic(edit, item)} src="image/{products[edit].image_paths[item]}">
	</Sortable>
	{#each products[edit].image_paths as image, j}
		{#if !products[edit].img.includes(j)}
			<img class="notselected" on:load={img_title_resolution} on:click={() => selectPic(edit, j)} src="image/{image}">
		{/if}
	{/each}
</div>